<template>
    <div class="table-list booking">
        <modal class="alarm" :display="alarm" @modalStatus="closeModal()" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>取消預定合約</h1>
            <div class="content">
                確定取消 ”{{alarmAddress}}”之結束預定合約嗎？記錄確認取消將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="rejectContract(), $analytics.logEvent('取消結束預定合約', { screen_name: '取消結束預定合約'})">確認</button>
                <button class="border-button" @click="closeModal()">取消</button>
            </div>
        </modal>
        <!-- <verified-alarm-modal></verified-alarm-modal> -->
        <div class="mask"></div>
        <div class="btn-group">
            <rent-select refName="booking" selectMsg="所有狀態" :setDefault="isDefault" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff">
                <ul>
                    <li data-id="1">
                        房東簽約
                    </li>
                    <li data-id="2">
                        租客簽約
                    </li>
                    <li data-id="7">
                        租客付押金
                    </li>
                </ul>
            </rent-select>
            <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
        </div>
        <task-menu :isOpen="taskMenu" :taskHouseInfo="taskHouseInfo" @taskClose="closeTaskMenu"></task-menu>
        <div class="table-list-title">
            <span class="progress">房源地址、進度</span>
            <span class="rent">租金</span>
            <span class="name">房源名稱</span>
            <span class="countdown">倒數</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-show="filterByWord.length == 0 && bookingList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
            </div>
            <div v-show="bookingList.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(house, index) in filterByWord" :key="index" >
                    <span class="progress">
                        <span class="address">{{house.address}}</span>
                        <span class="progress-bar">
                            <span class="progress-landlord" :class="{'active': house.contractStatus == 1}">
                                <img v-if="house.contractStatus == 1" src="@/assets/img/icon/radio_blue.svg" alt="">
                                <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                                房東簽約
                            </span>
                            <span class="progress-hr"></span>
                            <span class="progress-tanant" :class="{'active': house.contractStatus == 2}">
                                <img v-if="house.contractStatus == 2" src="@/assets/img/icon/radio_blue.svg" alt="">
                                <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                                租客簽約
                            </span>
                            <span class="progress-hr"></span>
                            <span class="progress-desposit" :class="{'active': house.contractStatus == 7}">
                                <img v-if="house.contractStatus == 7" src="@/assets/img/icon/radio_blue.svg" alt="">
                                <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                                租客付押金
                            </span>
                        </span>
                    </span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <span class="name">{{house.name}}</span>
                    <span class="countdown">
                        <img src="@/assets/img/icon/timer_gray.svg" alt="">
                        <count-down :timeStamp="translateDate(house.confirmDueDate)"></count-down>
                    </span>
                    <span v-if="house.contractStatus == 1" class="action" @click="openTaskMenu(), $analytics.logEvent('簽署合約', { screen_name: '簽署合約'})" :data-id="index">簽署合約</span>
                    <span v-else-if="house.contractStatus == 2" class="action" @click="openModal(), $analytics.logEvent('取消合約', { screen_name: '取消合約'})" :data-id="index">取消合約</span>
                    <span v-else class="action" @click="getContract(house.contractCid), $analytics.logEvent('查看合約', { screen_name: '查看合約'})" :data-id="index">查看合約</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import CountDown from '@/components/widge/CountDown.vue';
import TaskMenu from '@/components/landlord/houseStatus/TaskMenu.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import verifiedAlarmModal from '@/components/widge/verifiedAlarmModal.vue';
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

import { 
    apiGetBookingTableList,
    apiRejectContract
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            bookingList: [],
            taskMenu: false,
            taskHouseInfo: {},
            contractStatus: '',
            filterWord: '',
            filterEmpty: false,
            bookingDataEmpty: false,
            bookingDataError: false,
            isLoading: true,
            isDefault: false,
            deleteId: '',
            alarm: false
        }
    },
    mounted () {
        // this.$analytics.logEvent("預定管理-待簽署合約");
        this.getBookingList()
    },
    watch: {
        apiStatus: function () {
            if( this.apiStatus == 'update' ){
                this.getBookingList()
            }
        }
    },
    methods: {
        closeTaskMenu: function (value) {
            this.$store.commit('modalStatus/set_filter_mode', false)
            this.taskMenu = value
        },
        openTaskMenu: function () {
            if(this.userStatus == 1 || this.userStatus == 4 || this.userStatus == 6){
                this.$store.dispatch('setModalStatus', {state: true, type: 'verifiedAlarm'})
            }else{
                this.$store.commit('modalStatus/set_filter_mode', true)
                let bookingListId = event.target.dataset.id
                this.taskMenu = true
                this.taskHouseInfo = this.filterResult[bookingListId]
                this.taskHouseInfo.empty = 1
                this.taskHouseInfo.status = [1]
            }
            
            // console.log(this.filterResult[bookingListId])
        },
        getSelectId: function (value) {
            this.isDefault = false

            if( value.ref == 'booking' ){
                this.contractStatus = value.id
            }
        },
        setFilterWord: function (value) {
            this.isDefault = false
            this.filterWord = value
        },
        setFilterDefault: function (value) {
            this.isDefault = true
            this.filterWord = ''
            this.contractStatus = ''
        },
        getBookingList: function () {
            apiGetBookingTableList()
            .then(res => {
                // console.log('帶簽署',res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setApiStatus', 'success')
                    this.isLoading = false
                    if( res.data.result ){
                        if( res.data.result ){
                            this.bookingList= res.data.result
                        }else{
                            this.bookingDataEmpty = true
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        rejectContract: function () {
            let data = this.filterByWord[this.deleteId].contractCid;
            console.log(data)
            apiRejectContract(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    this.closeModal()
                    this.deleteId = null
                    this.getBookingList()
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        closeModal: function (type) {
            this.alarm = false
        },
        openModal: function () {
            this.alarm = true
            this.deleteId = event.target.dataset.id
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
            // let data = cid;

            // apiGetContract(data)
            // .then(res => {
            //     // console.log(res)
            //     if( res.data.status == "SUCCESS" ){
            //         window.open(baseDomain+res.data.result.electronicContract, '合約詳情')
            //     }
            // })
            // .catch(err => {
            //     reject(err)
            // })
        },
        translateDate: function (date) {

            let currentDate = new Date(date)
            currentDate = currentDate.setHours(currentDate.getHours())

            return currentDate
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        ...mapGetters({
            apiStatus: 'GET_STATUS',
            userStatus: 'GET_USER_STATUS',
        }),
        alarmAddress: function () {
            if( this.deleteId ){
                let address =  this.filterByWord[this.deleteId]
                return address.address
            }
        },
        filterByState: function () {
            return this.bookingList.filter((bookingItem) => {
                if( this.contractStatus ){
                    if( bookingItem.contractStatus == this.contractStatus ){
                        return bookingItem
                    }
                }else{
                    return bookingItem
                }
            });
        },
        filterByWord: function () {
            return this.filterByState.filter((bookingItem) => {
                if( this.filterWord ){
                    if( bookingItem.name.includes(this.filterWord) || bookingItem.address.includes(this.filterWord)){
                        return bookingItem
                    }
                }else{
                    return bookingItem
                }
            });
        },
        filterResult: function () {
            // if( this.filterByWord.length == 0 ){
            //     this.filterEmpty = true
            // }else{
            //     this.filterEmpty = false
            //     return this.filterByWord
            // }
            if( this.bookingDataEmpty == false && this.bookingDataError == false && this.isLoading == false ){
                if( this.filterByWord.length == 0 ){
                    this.filterEmpty = true
                }else{
                    this.filterEmpty = false
                    return this.filterByWord
                }
            }
        },
        
    },
    components: {
        CountDown,
        TaskMenu,
        RentSelect,
        TableSearch,
        verifiedAlarmModal,
        Modal
    }
}
</script>
<style lang="scss" scoped>
    .table-list.booking{
        
        .table-list-title .progress,
        .table-list-body ul li .progress{
            position: relative;
            width: 385px;
            margin-right: 100px;
            .address{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
        }
        .table-list-title .rent,
        .table-list-body ul li .rent{
            width: 51px;
            margin-right: 77px;
        }
        .table-list-body ul li .rent{
            text-align: right;
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 150px;
            margin-right: 55px;
        }
        .table-list-title .countdown,
        .table-list-body ul li > .countdown{
            width: 107px;
            margin-right: 90px;
        }
        .table-list-body ul li .progress{
            .address{
                display: block;
                margin-bottom: 20px;
            }
            .progress-bar{
                display: flex;
                align-items: center;
                .progress-landlord,
                .progress-tanant,
                .progress-desposit{
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #a8a5a4;
                    img{
                        margin-right: 8px;
                    }
                }
                .progress-landlord.active,
                .progress-tanant.active,
                .progress-desposit.active{
                    color: #71aae5;
                }
                .progress-landlord,
                .progress-tanant{
                    width: 72px;
                }
                .progress-desposit{
                    width: 85px;
                }
                .progress-hr{
                    width: 60px;
                    height: 1px;
                    background: #cacfcd;
                    margin: 0 8px;
                }
            }
        }
        .table-list-body ul li .countdown{
            display: flex;
            align-items: center;
            color: #676362;
        }
        .table-list-body ul li .action{
            color: #ff9275;
            cursor: pointer;
        }
        > .btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: -86px;
            right: 0px;
            .rent-select{
                width: 86px;
                background: #fff;
                padding: 14px 16px;
                margin-right: 16px;
            }
        }
        .alarm{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .table-list.booking{
            .table-list-title .progress,
            .table-list-body ul li .progress{
                margin-right: 96px;
            }
            .table-list-title .rent,
            .table-list-body ul li .rent{
                margin-right: 71px;
            }
            .table-list-title .name,
            .table-list-body ul li .name{
                margin-right: 51px;
            }
            .table-list-title .countdown,
            .table-list-body ul li > .countdown{
                margin-right: 86px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/bookingManagement/BookingTableList.vue